import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box } from '@mui/material';
import * as E from 'fp-ts/Either';
import { flow } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import { AsyncButton, SaveStates } from '../async-button';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";

var PureRedeemButton = function PureRedeemButton(_ref) {
  var mutationValue = _ref.mutationValue,
      disabled = _ref.disabled,
      tooltipText = _ref.tooltipText,
      redeemText = _ref.redeemText,
      savingText = _ref.savingText,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(Tooltip, {
    disableFocusListener: true,
    title: tooltipText,
    "data-element": "Tooltip",
    "data-component": "PureRedeemButton",
    "data-source-file": "redeem-button.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      component: "span",
      sx: {
        zIndex: function zIndex(t) {
          return t.zIndex._1;
        }
      },
      "data-element": "Box",
      "data-component": "PureRedeemButton",
      "data-source-file": "redeem-button.tsx",
      children: /*#__PURE__*/_jsx(AsyncButton, {
        status: mutationValue,
        disabled: disabled,
        text: [savingText, redeemText, redeemText, redeemText],
        onClick: onClick,
        "data-element": "AsyncButton",
        "data-component": "PureRedeemButton",
        "data-source-file": "redeem-button.tsx"
      })
    })
  });
};

var Saving = SaveStates.Saving,
    Default = SaveStates.Default,
    Error = SaveStates.Error;
var savingText = 'Redeeming...';

var useProps = function useProps(_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$tooltipText = _ref2.tooltipText,
      tooltipText = _ref2$tooltipText === void 0 ? disabled ? "You don't have enough points" : '' : _ref2$tooltipText,
      mutationStatus = _ref2.mutationStatus,
      onClick = _ref2.onClick,
      redeemText = _ref2.redeemText;
  var mutationValue = useMutationMapper(mutationStatus, function (_ref3) {
    var redeemReward = _ref3.redeemReward;
    return redeemReward.__typename === 'RedeemRewardErrors' ? E.left(redeemReward) : E.right(redeemReward);
  }, [Saving, Default, Error, Default]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return {
    mutationValue: mutationValue,
    disabled: disabled,
    tooltipText: tooltipText,
    onClick: onClick,
    savingText: t(savingText),
    redeemText: t(redeemText),
    t: t
  };
};

export default Object.assign(flow(useProps, PureRedeemButton), {
  displayName: 'RedeemButton'
});